import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOrcamento } from "app/types/IOrcamento";
import { resetAll } from "./actions/resetAll";

// Objeto constante para estado inicial
const EMPTY_ORCAMENTO: IOrcamento = {};

const initialState: IOrcamento = EMPTY_ORCAMENTO;

const atualizacaoOrcamentoLegadoSlice = createSlice({
    name: "atualizacaoOrcamentoLegado",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => EMPTY_ORCAMENTO),
    reducers: {
        atualizar: (state, action: PayloadAction<IOrcamento>) => {
            // Otimização: só atualiza se a referência for diferente
            if (action.payload !== state) {
                return action.payload;
            }
            return state; // Mantém estado atual se igual
        },
        limpar: (state) => {
            // Otimização: só limpa se não estiver vazio
            if (state !== EMPTY_ORCAMENTO) {
                return EMPTY_ORCAMENTO;
            }
            return state; // Mantém estado se já estiver limpo
        }
    }
});

export default atualizacaoOrcamentoLegadoSlice.reducer

export const {
    atualizar, limpar
}: {
    atualizar: ActionType<IOrcamento>,
    limpar: ActionType<void>
} = atualizacaoOrcamentoLegadoSlice.actions